export enum UserPreferenceKeysEnum {
    SHOW_WELCOME_MODAL,
    SHOW_ORDER_SETUP_BY_CSV_GUIDE,
}